'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselItem", {
    enumerable: true,
    get: function() {
        return CarouselItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselItem = require("./useCarouselItem");
const _renderCarouselItem = require("./renderCarouselItem");
const CarouselItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselItem.useCarouselItem_unstable)(props, ref);
    return (0, _renderCarouselItem.renderCarouselItem_unstable)(state);
});
CarouselItem.displayName = 'CarouselItem';
